/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJobLevel } from '../models/CompanyJobLevel';
import type { CompanyJobLevelSort } from '../models/CompanyJobLevelSort';
import type { CreateCompanyJobLevelRequest } from '../models/CreateCompanyJobLevelRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyLevelService {

    /**
     * Get company levels
     * @returns CompanyJobLevel Success
     * @throws ApiError
     */
    public static getCompanyLevels({
        sort,
        search,
        levelCode,
        levelTitle,
        companyJobCategoryId,
        limit,
        offset,
        ignorePagination,
    }: {
        /**
         * Sorting options
         */
        sort?: CompanyJobLevelSort,
        /**
         * Search
         */
        search?: string,
        /**
         * Filter by grade (level code)
         */
        levelCode?: Array<string>,
        /**
         * Filter by level title
         */
        levelTitle?: Array<string>,
        /**
         * Filter by job category
         */
        companyJobCategoryId?: Array<number>,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Ignore pagination
         */
        ignorePagination?: boolean,
    }): CancelablePromise<Array<CompanyJobLevel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/level',
            query: {
                'sort': sort,
                'search': search,
                'levelCode': levelCode,
                'levelTitle': levelTitle,
                'companyJobCategoryId': companyJobCategoryId,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create company level
     * @returns CompanyJobLevel Success
     * @throws ApiError
     */
    public static createCompanyLevel({
        requestBody,
    }: {
        requestBody?: CreateCompanyJobLevelRequest,
    }): CancelablePromise<CompanyJobLevel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/level',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Delete company job levels
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyJobLevels({
        levelIds,
    }: {
        /**
         * Level Ids To Delete
         */
        levelIds?: Array<number>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/level',
            query: {
                'levelIds': levelIds,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Return company job level
     * @returns CompanyJobLevel Success
     * @throws ApiError
     */
    public static getCompanyJobLevel({
        id,
    }: {
        /**
         * Company Job Level ID
         */
        id: number,
    }): CancelablePromise<CompanyJobLevel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/level/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update company level
     * @returns CompanyJobLevel Success
     * @throws ApiError
     */
    public static updateCompanyLevel({
        id,
        requestBody,
    }: {
        /**
         * Company Job Level ID
         */
        id: number,
        requestBody?: {
            companyJobCategoryId?: number;
            levelTitle?: string;
            levelDescription?: string | null;
            sort?: number;
        },
    }): CancelablePromise<CompanyJobLevel> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/level/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete company level
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyLevel({
        id,
    }: {
        /**
         * Company Job Level ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/level/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export company levels
     * @returns any Success
     * @throws ApiError
     */
    public static exportCompanyLevels(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/level/export',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}
